import { makeVar } from '@apollo/client'

const organizationIdStorageKey = 'organization-id'

const initialOrgId =
  typeof window !== 'undefined'
    ? localStorage.getItem(organizationIdStorageKey)
    : null

const organizationId = makeVar<string | null>(initialOrgId)

export const getOrganizationId = () => organizationId()

export const setOrganizationId = (value: string | null) => {
  if (!value) {
    localStorage.removeItem(organizationIdStorageKey)
  } else {
    localStorage.setItem(organizationIdStorageKey, value)
  }

  organizationId(value)
}
export const organizationIdVar = organizationId
